export default __webpack_public_path__ + "static/media/nuvemshop-platform-poster.e92d6325.png";